<app-loading
  *ngIf="showLoading"
  ngSkipHydration
  (finished)="hideLoading()">
</app-loading>

<section class="atw-page" [class.atw-page--loading]="showLoading" [attr.aria-busy]="showLoading">
  <app-header></app-header>

  <div class="shape shape-1"></div>
  <div class="shape shape-2"></div>
  <div class="dots dots-left"></div>
  <div class="dots dots-right"></div>

  <app-chat></app-chat>
  <router-outlet></router-outlet>

  <app-footer ngSkipHydration></app-footer>

  <!-- PWA Install Popup -->
  <div
    class="pwa-install-backdrop"
    *ngIf="showInstallPopup && isMobile"
    ngSkipHydration
    (click)="closeInstallPopup()">

    <div
      class="pwa-install-popup"
      [class.is-rtl]="isRtl"
      role="dialog"
      aria-modal="true"
      (click)="$event.stopPropagation()">

      <button
        type="button"
        class="pwa-close-btn"
        aria-label="Close"
        (click)="closeInstallPopup()">
        ×
      </button>

      <div class="pwa-icon-wrap">
        <span>📱</span>
      </div>

      <div class="pwa-content">
        <span class="pwa-badge">
          {{ 'atw.pwa.badge' | transloco }}
        </span>

        <h3>
          {{ 'atw.pwa.title' | transloco }}
        </h3>

        <p *ngIf="!isIos">
          {{ 'atw.pwa.description' | transloco }}
        </p>

        <p *ngIf="isIos">
          {{ 'atw.pwa.iosDescription' | transloco }}
        </p>

        <div class="pwa-ios-steps" *ngIf="isIos">
          <div>
            <b>1</b>
            <span>{{ 'atw.pwa.iosStep1' | transloco }}</span>
          </div>

          <div>
            <b>2</b>
            <span>{{ 'atw.pwa.iosStep2' | transloco }}</span>
          </div>
        </div>
      </div>

      <div class="pwa-actions">
        <button
          type="button"
          class="pwa-primary-btn"
          *ngIf="!isIos"
          (click)="installPWA()">
          <span>＋</span>
          {{ 'atw.pwa.installNow' | transloco }}
        </button>

        <button
          type="button"
          class="pwa-secondary-btn"
          (click)="closeInstallPopup()">
          {{ 'atw.pwa.later' | transloco }}
        </button>
      </div>
    </div>
  </div>
</section>
